import { useEffect } from 'react';
import { useBoolean } from '../../../utils/hooks/useBoolean';
import { useUploadQueueObservables } from '../../../utils/hooks/useFilesUploader';

export const useForceCloseUploadWindow = () => {
  const { queueChangeObservable } = useUploadQueueObservables();

  const {
    value: isUploadWindowForceClosed,
    setTrue: forceCloseUploadWindow,
    setFalse: resetForceCloseUploadWindow,
  } = useBoolean(false);

  useEffect(() => {
    const queueChangeSubscription = queueChangeObservable.subscribe(resetForceCloseUploadWindow);

    return () => {
      queueChangeSubscription.unsubscribe();
    };
  }, []);

  return {
    isUploadWindowForceClosed,
    forceCloseUploadWindow,
  };
};
